import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=084303d8&scoped=true&"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetail.vue?vue&type=style&index=0&id=084303d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084303d8",
  null
  
)

export default component.exports